import { StyleSheet, View } from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';

import { TAB_BARS } from 'store/App/constants';
import { useAppSelector } from 'store/hooks';
import { OrderDeliveryChannels } from 'store/Orders/enums';
import { SettingSelectors } from 'store/Settings';
import { UserSelectors } from 'store/User';
import { getIconNameForOrderKind } from 'util/helpers';
import { getDriverPictureURL } from 'util/helpers/cloudinary';
import { useNavigationContext } from 'util/hooks/useNavigationContext';
import { DriverAvatar, WebImage } from 'components';
import { CountDownLabel } from 'components/CountDownLabel';

import type { Order } from 'store/Orders/types';

type Props = {
  order: Order;
};

export const BadgeSection = ({ order }: Props) => {
  const { activeRouteKey } = useNavigationContext();
  const { shouldDisplayDriverDetails, shouldDisplayOrderChannel } =
    useAppSelector(SettingSelectors.selectOrderDetailsInterfaceSettings);

  const featureFlags = useAppSelector(UserSelectors.selectFeatureFlags);

  const { channel, assigned_driver: assignedDriver } = order;

  return (
    <View style={{ flexDirection: 'row', gap: 4, alignItems: 'flex-start' }}>
      <View style={styles.iconContainer}>
        <MaterialCommunityIcons
          name={getIconNameForOrderKind(order.kind)}
          color="white"
          size={28}
        />
      </View>
      {shouldDisplayOrderChannel &&
        channel &&
        channel.slug !== OrderDeliveryChannels.UNKNOWN && (
          <WebImage
            uri={channel.logo_cloudinary_url}
            width={40}
            height={40}
            shape={'rect'}
            borderRadius={5}
          />
        )}
      {shouldDisplayDriverDetails &&
        featureFlags.display_driver_details &&
        assignedDriver && (
          <DriverAvatar
            uri={getDriverPictureURL(assignedDriver.profile_picture_id)}
            fullName={assignedDriver.full_name}
            size={36}
            style={[
              styles.iconContainer,
              {
                alignSelf: 'flex-end',
              },
            ]}
          />
        )}
      {Boolean(order.latest_pickup_time) &&
        [
          TAB_BARS.new.value,
          TAB_BARS.cooking.value,
          TAB_BARS.scheduled.value,
        ].includes(activeRouteKey) && (
          <CountDownLabel
            latestPickupTime={order.latest_pickup_time}
            style={styles.iconContainer}
          />
        )}
    </View>
  );
};

const styles = StyleSheet.create({
  iconContainer: {
    borderRadius: 4,
    borderColor: '#fff',
    borderWidth: 1,
    flex: 1,
    flexBasis: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    height: 36,
    marginTop: 0,
  },
});
